const stats = [
  { value: '500万+', label: '活跃用户' },
  { value: '10万+', label: '优质文章' },
  { value: '50万+', label: '日均访问' },
  { value: '99.9%', label: '服务可用率' },
];

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-secondary-500">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/80">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}